(function () {
  'use strict';

  var SHOW_DELAY_MS = 3000;
  var SUCCESS_AUTO_CLOSE_MS = 9000; // give people real time to read/screenshot the code before it auto-closes
  var DISMISS_SNOOZE_MS = 1000 * 60 * 60 * 24 * 7; // don't re-prompt for 7 days after a manual close
  var SUBSCRIBED_KEY = 'hsWelcomeSubscribed';
  var DISMISSED_KEY = 'hsWelcomeDismissedAt';

  document.addEventListener('DOMContentLoaded', function () {
    var popup = document.getElementById('hs-welcome-popup');
    if (!popup) return; // not rendered for logged-in customers / cart page

    var closeEls = popup.querySelectorAll('[data-hs-welcome-close]');
    var copyBtn = popup.querySelector('[data-hs-welcome-copy]');
    var emailInput = popup.querySelector('#hs-welcome-email');

    function show() {
      popup.hidden = false;
      popup.classList.add('is-visible');
      popup.setAttribute('aria-hidden', 'false');
      document.body.classList.add('hs-welcome-popup-open');
      if (emailInput) {
        window.setTimeout(function () { emailInput.focus(); }, 300);
      }
    }

    function hide(markDismissed) {
      popup.hidden = true;
      popup.classList.remove('is-visible');
      popup.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('hs-welcome-popup-open');
      if (markDismissed) {
        try { localStorage.setItem(DISMISSED_KEY, String(Date.now())); } catch (e) {}
      }
    }

    function copyCode(code, button) {
      if (!navigator.clipboard || !code) return;
      navigator.clipboard.writeText(code).then(function () {
        if (button) {
          var original = button.textContent;
          button.textContent = 'Copied!';
          window.setTimeout(function () { button.textContent = original; }, 2000);
        }
      });
    }

    closeEls.forEach(function (el) {
      el.addEventListener('click', function () { hide(true); });
    });

    document.addEventListener('keydown', function (e) {
      if (!popup.hidden && e.key === 'Escape') hide(true);
    });

    if (copyBtn) {
      copyBtn.addEventListener('click', function () {
        copyCode(copyBtn.getAttribute('data-hs-welcome-copy'), copyBtn);
      });
    }

    var postedSuccessfully = popup.getAttribute('data-hs-welcome-posted') === '1';

    if (postedSuccessfully) {
      // The form on this page load just posted successfully (native Shopify
      // customer-form redirect-back) — show the success state immediately,
      // no delay, remember it so the popup never nags this visitor again,
      // auto-copy the code straight to clipboard so it's usable even if
      // someone closes right away, and auto-dismiss after a generous window
      // rather than requiring a click (manual close still works throughout).
      try { localStorage.setItem(SUBSCRIBED_KEY, '1'); } catch (e) {}
      show();
      if (copyBtn) {
        window.setTimeout(function () {
          copyCode(copyBtn.getAttribute('data-hs-welcome-copy'), copyBtn);
        }, 400);
      }
      window.setTimeout(function () { hide(false); }, SUCCESS_AUTO_CLOSE_MS);
      return;
    }

    var subscribed = false;
    var dismissedAt = null;
    try {
      subscribed = localStorage.getItem(SUBSCRIBED_KEY) === '1';
      dismissedAt = localStorage.getItem(DISMISSED_KEY);
    } catch (e) {}

    if (subscribed) return;
    if (dismissedAt && (Date.now() - parseInt(dismissedAt, 10)) < DISMISS_SNOOZE_MS) return;

    window.setTimeout(show, SHOW_DELAY_MS);
  });
})();
